import React from "react";
import { Link } from "react-router";
import { useIsSmallScreen } from "../../App";
import { CalendarDay, getDayNameFromLabel } from "../../calendar/utils";
import { HORIZONTAL_RULE_COLOR } from "../../tokens";

export const CalendarRow: React.FC<{
    day: CalendarDay;
    labelOverride?: string;
}> = (props) => {
    const { day, labelOverride } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <div
            style={{
                borderTop:
                    labelOverride === "Yesterday"
                        ? ""
                        : `1px solid ${HORIZONTAL_RULE_COLOR}`,
                paddingBottom: 8,
                paddingTop: 8,
                display: "flex",
                alignItems: isSmallScreen ? "flex-start" : "center",
                flexDirection: isSmallScreen ? "column" : "row",
            }}
            key={`${day.date} ${day.month}`}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexGrow: 1,
                }}
            >
                <div
                    style={{
                        width: 70,
                        flexShrink: 0,
                        fontWeight:
                            labelOverride === "Today" ? "bold" : undefined,
                    }}
                >
                    {labelOverride ? (
                        labelOverride
                    ) : (
                        <>
                            {day.dayOfTheWeek[0].toLocaleUpperCase() +
                                day.dayOfTheWeek.substr(1)}{" "}
                            {day.date}
                        </>
                    )}
                </div>
                <div
                    style={{
                        fontWeight: day.label ? "bold" : "normal",
                        flexGrow: 1,
                    }}
                >
                    {day.label
                        ? getDayNameFromLabel(day.label)
                        : day.blackLetterDay
                        ? day.blackLetterDay.optional
                            ? `(commonly: ${day.blackLetterDay.title})`
                            : day.blackLetterDay.title
                        : undefined}
                </div>
            </div>
            <div
                style={{
                    fontWeight: "bold",
                }}
            >
                <Link to={`/pray/${day.year}/${day.month}/${day.date}/mattins`}>
                    Mattins
                </Link>
                &nbsp;&nbsp;
                <Link
                    to={`/pray/${day.year}/${day.month}/${day.date}/evensong`}
                >
                    Evensong
                </Link>
                &nbsp;&nbsp;
                <Link
                    to={`/pray/${day.year}/${day.month}/${day.date}/compline`}
                >
                    Compline
                </Link>
            </div>
        </div>
    );
};
